// redux/slices/generalOptionsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify, notifyAPIMessages } from "../../../helpers/commonFunctions";
import { apiEndPoints } from "../../../helpers/constants";
import { BASE_URL } from "../../../config";
import { authHeaders } from "../../../helpers/axios";

// Generic thunk to fetch public API options dynamically

// Fetch Discount Usage Reports
export const reqToGetDiscountUsageReports = createAsyncThunk(
  "reqToGetDiscountUsageReports",
  async ({ data = {}, onSuccess, onFailure }, thunkAPI) => {
    try {
      const { page = 1, limit = 10, ...filters } = data;

      const response = await axios.get(
        `${BASE_URL}${apiEndPoints.discountUsage}?page=${page}&limit=${limit}`,
        authHeaders()
      );

      onSuccess?.(response?.data);

      // Return only the data part, not the entire axios response
      return response.data;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure?.(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

const ReportSlice = createSlice({
  name: "reposrtSlice",
  initialState: {
    discountUsageReports: [],
    reportsLoader: false,
    reportsError: null,
  },
  reducers: {
    // Add any specific reducers if needed
  },
  extraReducers: (builder) => {
    builder.addCase(reqToGetDiscountUsageReports.pending, (state) => {
      state.reportsLoader = true;
      state.reportsError = null;
    });
    builder.addCase(reqToGetDiscountUsageReports.fulfilled, (state, action) => {
      state.reportsLoader = false;
      state.reportsError = null;
      state.discountUsageReports = action.payload?.result || []; // Now access directly from payload
    });
    builder.addCase(reqToGetDiscountUsageReports.rejected, (state, action) => {
      state.reportsLoader = false;
      state.reportsError = action.payload;
      notifyAPIMessages(action.payload?.message || "Failed to fetch reports");
    });
  },
});

export default ReportSlice.reducer;
